import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { EmailTemplatesService } from 'application/email-templates/services';
import { resolveColumns } from 'application/facility/util/resolveColumns';
import { action } from 'mobx';

@applicationContext
class EmailTemplatesListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const service = new EmailTemplatesService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'email-templates',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {
                create: () => this.rootStore.routerStore.goTo(
                    'master.app.main.email-templates.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i =>
                        i.id === item.id,
                        () => item.name
                    );
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.email-templates.edit',
                        { id: item }
                    )
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find({
                            ...params
                        });

                        return response.data;
                    },
                    delete: async (item) => {
                        await service.delete(item);
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'EMAIL_TEMPLATES.LIST.COLUMNS.NAME'
                },
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item.id),
              /*   onDelete: async (item) => this.deleteResource(item) */
            }
        }));
    }

    @action.bound
    notifySuccessDelete() {
        this.rootStore.notificationStore.success('EMAIL_TEMPLATES.LIST.ACTIONS.SUCCESS_DELETE');
    }
}

export default EmailTemplatesListViewStore;
